import { CHANGE_HEADER_THEME } from "../types/Header";

export function changeHeaderTheme (headerTheme) {
    return {
        type: CHANGE_HEADER_THEME,
        payload: headerTheme
    }
}